import { render, staticRenderFns } from "./ProfileTalentCharitiesAndSponsors.vue?vue&type=template&id=2e0acc73"
import script from "./ProfileTalentCharitiesAndSponsors.vue?vue&type=script&lang=js"
export * from "./ProfileTalentCharitiesAndSponsors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports